module.exports = __webpack_public_path__ + "static/media/IMG_3504_sm.29051eb9.jpg";